<script>
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { handleNav } from "$lib/utilities/handleNav";
	import { getMenuAry } from "$lib/utilities/getMenuAry";
	import { store } from "$lib/utilities/store";

	export let data;
	export let lang;
	export let area;

	$: menus = data?.content?.["settings"]?.["Header"] || {};

	$: menuAry = getMenuAry(menus, lang, area, data, $store);
</script>

{#if lang}
	{#each menuAry as menu}
		{#if menu.options}
			<!-- Dropdown Menu -->
			<li
				class="hidden md:block my-auto dropdown dropdown-hover dropdown-bottom dropdown-end"
			>
				<div
					class="flex mx-auto hover:scale-110 transition-all ease-in-out duration-300"
					role="button"
					tabindex="0"
				>
					<span class={`flex whitespace-nowrap ${menu.class || ""}`}>
						{#if menu.labelIcon}
							<SvelteFa
								icon={menu.labelIcon}
								size="1x"
								class="h-full my-auto mx-auto"
							/>
						{/if}
						{menu.label}
					</span>
					<div class="">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							width="24"
							height="24"
							fill="currentColor"
						>
							<path d="M6 9l6 6 6-6" />
						</svg>
					</div>
				</div>
				<ul class="dropdown-content bg-base-300 px-4 z-1" tabindex="-1">
					{#each menu.options as option}
						<li class=" my-4">
							<a
								class={`whitespace-nowrap ${option.class || ""} block hover:scale-110 transition-all ease-in-out duration-300`}
								href={`${option.href}`}
								persistSearch={option.persistSearch}
								onclick={handleNav}
							>
								{option.label}
							</a>
						</li>
					{/each}
				</ul>
			</li>
			<li class="md:hidden">
				{#if menu.href}
					<a
						class={`whitespace-nowrap ${menu.class || ""} block hover:scale-110 transition-all ease-in-out duration-300`}
						href={`${menu.href}`}
						persistSearch={menu.persistSearch}
						onclick={handleNav}
					>
						{menu.label}
					</a>
				{:else}
					<span class={`whitespace-nowrap ${menu.class || ""}`}>
						{menu.label}
					</span>
				{/if}
				<ul>
					{#each menu.options as option}
						<li class="">
							<a
								class={`whitespace-nowrap ${option.class || ""} block hover:scale-110 transition-all ease-in-out duration-300`}
								href={`${option.href}`}
								persistSearch={option.persistSearch}
								onclick={handleNav}
							>
								{option.label}
							</a>
						</li>
					{/each}
				</ul>
			</li>
		{:else}
			<li class={`my-auto `}>
				<a
					href={menu.href}
					persistSearch={menu.persistSearch}
					onclick={handleNav}
					class={`whitespace-nowrap ${menu.class || ""} block hover:scale-110 transition-all ease-in-out duration-300`}
				>
					{menu.label}
				</a>
				<!-- <a href="/" class="">{menu.label}</a> -->
			</li>
		{/if}
	{/each}
{/if}
